import React from 'react';
import { useTranslation } from 'react-i18next';
import './EmptyBox.css';

export const EmptyBox = (props) => {
  const { t } = useTranslation('library');

  return (
    <div className="empty-box-container">
      <span
        className="empty-box-text"
        style={{
          fontSize: '0.75rem',
          textAlign: 'center',
        }}
      >
        {props?.label || t('No Data Available')}
      </span>
    </div>
  );
};
